import { render, staticRenderFns } from "./taskOptions.vue?vue&type=template&id=8688994a&"
import script from "./taskOptions.vue?vue&type=script&lang=js&"
export * from "./taskOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8688994a')) {
      api.createRecord('8688994a', component.options)
    } else {
      api.reload('8688994a', component.options)
    }
    module.hot.accept("./taskOptions.vue?vue&type=template&id=8688994a&", function () {
      api.rerender('8688994a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/taskOptions.vue"
export default component.exports